import { useEffect, useState } from "react";

import { warehouseService } from "~/api/warehouse";
import { useAppDispatch, useAppSelector } from "~/app/store";
import { convertRoutePathToWorkstationModePath } from "~/lib/workstations.logic";
import { StoreState } from "~/redux/reducers";

import { WorkstationModePath } from "~/redux/reducers/workstations";
import { selectAuthHeaderReady } from "~/redux/selectors/appSelectors";

import { andonApi } from "~/redux/warehouse/andon";
import { useLazyGetWorkstationsQuery } from "~/redux/warehouse/workstation.hooks";

/** Sends an update-mode event to warehouse as the user moves to different parts of the app */
function useModeUpdate({ pathname }: { pathname: string }) {
  const dispatch = useAppDispatch();
  const currentWorkstationId = useAppSelector(
    (state: StoreState) => state.workstations.siteWorkstation?.id
  );
  const [triggerFetchWorkstations] = useLazyGetWorkstationsQuery();

  const isAuthHeaderReady = useAppSelector(selectAuthHeaderReady);
  const selectedFulfillmentCenter = useAppSelector(
    (state) => state.store.usersFulfillmentCenter
  );

  const [currentMode, setCurrentMode] = useState<WorkstationModePath | null>(
    null
  );

  // defaults to "standby"
  const newMode = convertRoutePathToWorkstationModePath(pathname);

  useEffect(() => {
    if (
      !isAuthHeaderReady ||
      !selectedFulfillmentCenter ||
      !currentWorkstationId
    )
      return;
    // if user/workstation switches from one mode to another, post updated mode to warehouse
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (newMode && newMode !== currentMode) {
      void warehouseService
        .post(`/api/workstations/${currentWorkstationId}/mode/${newMode}`)
        .then(() => {
          setCurrentMode(newMode);
          void triggerFetchWorkstations();
          dispatch(andonApi.util.invalidateTags(["andon workstations"]));
        });
    }
  }, [
    newMode,
    isAuthHeaderReady,
    selectedFulfillmentCenter,
    currentWorkstationId,
    currentMode,
    dispatch,
    triggerFetchWorkstations
  ]);
}

export default useModeUpdate;
